import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../features/auth/authSlice';
import commonReducer from '../features/common/commonSlice'

export const store = configureStore({
  reducer: {
    auth: authReducer,
    common: commonReducer
  },
});
